import { render, staticRenderFns } from "./vipExperienceDialog.vue?vue&type=template&id=35194a27"
import script from "./vipExperienceDialog.vue?vue&type=script&lang=js"
export * from "./vipExperienceDialog.vue?vue&type=script&lang=js"
import style0 from "./vipExperienceDialog.vue?vue&type=style&index=0&id=35194a27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports